export enum Action {
    Approve = 'approve',
    Reject = 'reject',
    Publish = 'publish',
    Archive = 'archive',
    Review = 'review',
}
